//=============================================================================
// Contents   : HRDB
//              部署マスタ情報データ出力
//              FmtDepartment
// Author     : RV上田
// LastUpdate : 2023/1/23
// Since      : 2023/1/23
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';

/* ====== CSS ====== */
// import styled from "styled-components";
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Title } from "01Pages/Common/UiParts/Title";
/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount, CFStringDecodeJP, CFStringEncodeJP } from "03CommonApiParts/CommonFunction";
import { useProvideData } from "03CommonApiParts/use-context";
import { CreateExcel } from "03CommonApiParts/CreateExcel";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */ 

/* ====== Styled Components ====== */
/* ------ページコンテンツ ------*/

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */
/* ベース64スイッチ */
const CommonStyle =  StyleCommon();//共通スタイルドコンポーネント
const base64Swicth = true;
/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */



/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

/* ========= 登録画面テンプレート ========= */
export const FmtDepartment = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

     const navigate = useNavigate();//画面遷移用
     const apiData = useProvideData();//APIデータ取得
     const location = useLocation();

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, handleSubmit ,formState: { errors } } = useForm({
            mode: 'onBlur',
            reValidateMode: 'onChange',
            shouldUseNativeValidation: false,
            shouldUnregister: false,
            escalationCode:'false'
        });

    /* ====== useWatchを定義 ====== */


    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    let today = new Date();//今日の日付を取得
    // yyyy-mm-ddの形に変える
    const year = today.getFullYear();//年を取得
    const month = ('00' + (today.getMonth()+1)).slice(-2)//月を取得
    const day = ('00' + (today.getDate())).slice(-2);//日を取得
    today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する
    const dataRow = {
        otpDate:today
    };
    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

        

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        // /* 画面表示開始 */
        setLoading(true);
        // eslint-disable-next-line
    },[]);

    /* ====== 出力ボタン押した時の処理 ====== */
	const onClickOutput = async(row) => {
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
		const apiPath = '/master/getformatupdatedepartment';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
        /* キー */
		key.otpDate = row.payload.otpDate;

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

		/* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, async(result) => {

			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const apiPathExcel = '/common/registeroutputrecord';
                /* リクエスト*/
                const keyExcel = {};
                
                /* キー */
                keyExcel.dlFileId = screenId;
                keyExcel.dlCdt = [{
                    sarCd: 'otpDate',
                    sarValue: key.otpDate
                }];

                /* リクエストパラメータ */
                const apiBodyExcel = {handlingInformation:handlingInformation, key:keyExcel};

                /* API処理開始 */
                await apiData.getDataPost(apiPathExcel, apiBodyExcel, (excelResult) => {
                    /* プログレスバー非表示 */
                    setProgress(false);
                    if (excelResult.isSuccessed) {//APIリクエスト結果 = 正常
                        const data = result.responseData.data.payload;
                        const dataEdit = [];
                        data.forEach((row)=>{
                            const dataObject = {};
                            dataObject.dptCd = row.dptCd;
                            dataObject.dptHqName = CFStringDecodeJP(row.dptHqName,base64Swicth);
                            dataObject.dptHqEngName = row.dptHqEngName;
                            dataObject.dptHqOrd = row.dptHqOrd;
                            dataObject.dptPartName = CFStringDecodeJP(row.dptPartName,base64Swicth);
                            dataObject.dptPartEngName = row.dptPartEngName;
                            dataObject.dptPartOrd = row.dptPartOrd;
                            dataObject.dptRomName = CFStringDecodeJP(row.dptRomName,base64Swicth);
                            dataObject.dptRomEngName = row.dptRomEngName;
                            dataObject.dptRomOrd = row.dptRomOrd;
                            dataObject.dptGpName = CFStringDecodeJP(row.dptGpName,base64Swicth);
                            dataObject.dptGpEngName = row.dptGpEngName;
                            dataObject.dptGpOrd = row.dptGpOrd;
                            dataObject.dptAbrName = CFStringDecodeJP(row.dptAbrName,base64Swicth);
                            dataObject.upperDptCd = row.upperDptCd;
                            dataObject.dptLevel = row.dptLevel;
                            dataObject.lboCstClasfName = CFStringDecodeJP(row.lboCstClasfName,base64Swicth);
                            dataObject.projSgmtCd = row.projSgmtCd;
                            dataObject.partWithinCmmKbjCd = row.partWithinCmmKbjCd;
                            dataObject.salesMnaExpePjCd = row.salesMnaExpePjCd;
                            dataObject.lboCstPjCd = row.lboCstPjCd;
                            dataObject.mnaEmpNmb  = row.mnaEmpNmb;
                            dataObject.dptChangeCont = CFStringDecodeJP(row.dptChangeCont, base64Swicth);
                            dataEdit.push(dataObject);
                        });
                        /* エクセルの設定 */
                        const excelConfig = [
                            { id:'dptCd', name:'部署コード', type:'normal'},
                            { id:'dptHqName', name:'本部', type:'normal'},
                            { id:'dptHqEngName', name:'本部_英名', type:'normal'},
                            { id:'dptHqOrd', name:'本部順', type:'normal'},
                            { id:'dptPartName', name:'部', type:'normal'},
                            { id:'dptPartEngName', name:'部_英名', type:'normal'},
                            { id:'dptPartOrd', name:'部順', type:'normal'},
                            { id:'dptRomName', name:'室', type:'normal'},
                            { id:'dptRomEngName', name:'室_英名', type:'normal'},
                            { id:'dptRomOrd', name:'室順', type:'normal'},
                            { id:'dptGpName', name:'G', type:'normal'},
                            { id:'dptGpEngName', name:'G_英名', type:'normal'},
                            { id:'dptGpOrd', name:'G順', type:'normal'},
                            { id:'dptAbrName', name:'部署略名', type:'normal'},
                            { id:'upperDptCd', name:'上位部署コード', type:'normal'},
                            { id:'dptLevel', name:'部署レベル', type:'normal'},
                            { id:'lboCstClasfName', name:'人件費区分', type:'normal'}, 
                            { id:'projSgmtCd', name:'事業セグメント', type:'normal'}, 
                            { id:'partWithinCmmKbjCd', name:'部内共通(KBJ)コード', type:'normal'}, 
                            { id:'salesMnaExpePjCd', name:'販管費PJコード', type:'normal'}, 
                            { id:'lboCstPjCd', name:'人件費PJコード', type:'normal'}, 
                            { id:'mnaEmpNmb', name:'所属長', type:'normal'}, 
                            { id:'dptChangeCont', name:'変更内容', type:'normal'},
                            { id:'aplySrtDate', name:'適用日', type:'normal'}
                        ]
                        /* エクセル出力 */
                        CreateExcel('部署マスタ_登録用', excelConfig,dataEdit,null,null,row.payload.otpDate);
                        /* プログレスバー非表示 */
                        setProgress(true);
                        /* 出力完了画面へ遷移 */
                        navigate('/common/completion',
                            {state:
                                {
                                    title:'部署マスタ情報出力完了',
                                    message: screenDisplayMessage('CMNI007'),
                                    button:[
                                        {name:'一覧画面へ戻る',path:'/master/department/list'},
                                    ]
                                },
                                replace:true
                            }
                            
                        );
                        
                    }else{//APIリクエスト結果 = 異常
                        /* スナックバー表示 */
                        setSnackbarMessage({      
                            ...snackbarMessage,
                            open:true,
                            message:result,//APIによるエラー
                            $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
                            type: 1,//APIエラー時:1,それ以外:2 
                            level:'error',//エラースナックバー
                        })
                    }
                });
            }else{//APIリクエスト結果 = 異常
                /* プログレスバー非表示 */
                setProgress(false);
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            }
        });
	};

    const onClickBack = () => {
		navigate('/master/department/list')
    }

	/* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== LeftTitleテーブルの設定 ====== */
    //id:idを指定
    //label:左側に表示するタイトル*
    //list:右側に表示するコンテンツのリスト *
    //name:項目名
    //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
    //title:inputなどの隣に表示するタイトル
    //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
    //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
    //disable:変更不可にする true/false
    //readOnly:ラベル風にする　true/false（select/date/datetime)
    //width:幅の変更をする(inputのみ)

    /* ====== LeftTitleテーブルのデータ ====== */
	const tableConfig = [
		{
			id:'row1',
			label:'日付入力',
            toolTip:true,
            exp:'指定した基準日時点の部署マスタ情報を出力します。',
			list:[
				{name:'otpDate',type:'date',required:true},
			]
		}
	]

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバーの表示 */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <Title text='一括登録用フォーマット出力' dataRow={dataRow}/>

            {/* <Table /> */}
            <CommonStyle.GdivPageContentsWrapper >
                {/* ページコンテンツ */}
				<form onSubmit={handleSubmit(onClickOutput)} >
                    
                    <div style={{marginTop:'10px'}}>
                        個人情報が含まれているため、取扱には十分注意してください。
                        <LeftTitleTable
                            className='baseText'
                            register={register}
                            payload='payload'
                            errors={errors}
                            dataRow={dataRow}
                            tableConfig={tableConfig}
                            getValues={getValues}
                            setValue={setValue}
                        />
					</div>
                    {/* アンダーバー */}
                    <Underbar
                        type='outputBack' //react-hook-form
                        onClickLeft={onClickBack}//戻るボタン押下時の処理
                    />
				</form>
            </CommonStyle.GdivPageContentsWrapper>
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
            />
                
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */